(() => {
  'use strict';
  if (window.RCWShopify) { window.RCWShopify.scan(); return; }
  const instances = new WeakMap();
  function mount(root) {
    if (instances.has(root)) return;
    const abort = new AbortController(), opts = { signal: abort.signal };
    function setImage(src, alt) {
      const image = root.querySelector('.product-gallery img');
      if (!image || !src) return;
      image.removeAttribute('srcset'); image.src = src;
      if (alt) image.alt = alt;
    }
    root.addEventListener('click', event => {
      const image = event.target.closest('[data-rcw-image]');
      if (image) setImage(image.dataset.rcwImage, image.dataset.alt);
    }, opts);
    root.addEventListener('change', event => {
      if (!event.target.matches('[data-rcw-variant]')) return;
      const option = event.target.selectedOptions[0];
      if (!option) return;
      window.RCFitGuide?.selectProduct(root, option.dataset.fitModel || '');
      const price = root.querySelector('[data-rcw-price]'), add = root.querySelector('[data-rcw-add]');
      if (price) price.textContent = option.dataset.price;
      const available = option.dataset.available === 'true';
      if (add) { add.disabled = !available; add.textContent = available ? 'Add to bag ↗' : 'Sold out'; }
      setImage(option.dataset.image || event.target.dataset.defaultImage);
    }, opts);
    instances.set(root, { destroy() { abort.abort(); instances.delete(root); } });
  }
  function scan(scope = document) {
    if (scope.matches?.('[data-rcw]')) mount(scope);
    scope.querySelectorAll?.('[data-rcw]').forEach(mount);
  }
  function destroy(scope) {
    if (scope.matches?.('[data-rcw]')) instances.get(scope)?.destroy();
    scope.querySelectorAll?.('[data-rcw]').forEach(root => instances.get(root)?.destroy());
  }
  window.RCWShopify = { scan, destroy };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));

  // Open Shopify's actual preference dialog when the configured native banner is available.
  // Without it, the real privacy-policy link remains a working fallback. No consent is set here.
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-rc-privacy]');
    if (!link || typeof window.privacyBanner?.showPreferences !== 'function') return;
    event.preventDefault();
    const status = link.closest('.rc-legal-links')?.querySelector('[data-rc-privacy-status]');
    const failed = () => {
      if (status) { status.hidden = false; status.textContent = 'Privacy settings could not open. Please try again or read the Privacy Policy.'; }
    };
    if (status) status.hidden = true;
    try { Promise.resolve(window.privacyBanner.showPreferences()).catch(failed); }
    catch { failed(); }
  });
})();
